import { format, parseISO } from 'date-fns';

/** Get today's date as YYYY-MM-DD */
export function getTodayDateString(): string {
  return format(new Date(), 'yyyy-MM-dd');
}

/** Format ISO timestamp to readable time (e.g., "09:30 AM") */
export function formatTime(isoString: string): string {
  return format(parseISO(isoString), 'hh:mm a');
}

/** Format ISO timestamp to readable date (e.g., "Feb 17, 2026") */
export function formatDate(isoString: string): string {
  return format(parseISO(isoString), 'MMM dd, yyyy');
}

/** Format ISO timestamp to date + time (e.g., "Feb 17, 2026 09:30 AM") */
export function formatDateTime(isoString: string): string {
  return format(parseISO(isoString), 'MMM dd, yyyy hh:mm a');
}

/** Format distance in km (e.g., "3.2 km") */
export function formatDistance(km: number): string {
  if (km < 1) {
    return `${Math.round(km * 1000)} m`;
  }
  return `${km.toFixed(1)} km`;
}
